module.exports = __webpack_public_path__ + "img/inbox-arrow-down.32f6b3c9.svg";